import React from 'react';
import { Container } from 'react-bootstrap';
import { BrowserRouter as Router, Link } from "react-router-dom";
import NavbarHook from '../hooks/NavbarHook';
import LogoutForm from './LogoutForm';
import Footer from './Footer';

import Logo from '../../img/asiera-logo-white.png';

function Layout({user, appFns, children}) {
    return <Router>
        <header>
            <NavbarHook>
                <Container>
                    <Link to="/" className="navbar-brand">
                        <img alt="" src={Logo} height="60" className="d-inline-block align-bottom" />{' '}
                    </Link>
                    <h3 className="Nav-title">PDU Management</h3>
                    {user.accessLevel >= 2 && 
                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul className="navbar-nav">
                                <li className="nav-item">
                                    <Link to="/" className="nav-link">Datacentres</Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="/users" className="nav-link">Users</Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="/groups" className="nav-link">Groups</Link>
                                </li>
                            </ul>
                        </div>
                    }
                </Container>
            </NavbarHook>
        </header>
        <main role="main">
            <Container>
                <LogoutForm username={user.username} logoutFunction={appFns.logout}></LogoutForm>
                {children}
            </Container>
        </main>
        <Footer></Footer>
    </Router>
}

export default Layout;
